const state = () => {
  return {
    work_machines: [],
    work_machine: {},
    work_machine_costs: [],
    work_machine_cost: {},
    work_machine_cost_types: [],
    work_machine_filters: {},
  }
}

export default state;
